<div class="mct-flex mct-col">
  <h2>{{ 'revenue.invoice-generator.title' | translate | titlecase }}</h2>
  <a class="mct-flex mct-row mct-justify-end mct-items-center" *ngIf="!hideBatchDelete" (click)="launchDeleteBatchModal()">{{
    'revenue.invoice-generator.delete-previous-batch' | translate | titlecase
  }}</a>
  <div class="mb-33 mct-flex mct-row mct-wrap mct-gap-80 mct-gap-0-lt-sm mct-flex-1-1-auto-lt-sm">
    <div class="mb-27 mct-flex mct-col mct-gap-27 mct-flex-0-0-330px mct-flex-1-1-auto-lt-sm">
      <div class="mct-flex mct-col">
        <label>
          {{ 'revenue.invoice-generator.month-label' | translate | titlecase }}
        </label>
        <p-select
          [options]="allMonths"
          optionLabel="MonthName"
          [style]="{ width: '100%' }"
          [(ngModel)]="selectedMonth"
          appendTo="body"
        ></p-select>
      </div>

      <div class="mct-flex mct-row mct-gap-17">
        <div class="mct-flex mct-col mct-flex-1-1-auto">
          <label>{{ 'revenue.invoice-generator.invoice-date-label' | translate | titlecase }}</label>
          <wl-date-selector [(ngModel)]="invoiceGenerationParams.InvoiceDate"></wl-date-selector>
        </div>
        <div class="mct-flex mct-col mct-flex-1-1-auto">
          <label>{{ 'revenue.invoice-generator.apply-year-label' | translate | titlecase }}</label>
          <p-input-number
            [style]="{ width: '100%' }"
            [useGrouping]="false"
            [(ngModel)]="invoiceGenerationParams.BillingYear"
          ></p-input-number>
        </div>
      </div>

      <div class="mct-flex mct-col">
        <label>{{ 'revenue.invoice-generator.email-label' | translate | titlecase }}</label>
        <input class="form-control" type="email" [(ngModel)]="invoiceGenerationParams.NotificationEmail" />
      </div>
    </div>
    <div class="mct-flex mct-col mct-gap-27 mct-flex-1-1-auto">
      <div class="mct-flex mct-col atlas-autocomplete">
        <label>{{ 'revenue.invoice-generator.revenue-items-label' | translate | titlecase }}</label>
        <p-autocomplete
          [suggestions]="revItemSearchResult"
          [(ngModel)]="selectedRevenueItems"
          [inputStyle]="{ width: '100%', minHeight: '90px' }"
          (completeMethod)="searchRevenueItems($event)"
          [dataKey]="'ItemNum'"
          optionLabel="ItemName"
          [multiple]="true"
          [forceSelection]="true"
        >
        </p-autocomplete>
      </div>

      <div class="mct-flex mct-col">
        <label>{{ 'revenue.invoice-generator.memo-label' | translate | titlecase }}</label>
        <textarea class="large-input" [(ngModel)]="invoiceGenerationParams.Memo"></textarea>
      </div>
    </div>
  </div>
  <div class="right-align">
    <button pButton type="button" class="atlas-btn atlas-btn-secondary mr-10" (click)="launchIncreaseModal()">
      {{ 'revenue.invoice-generator.update-amounts' | translate | uppercase }}
    </button>
    <button pButton type="button" class="atlas-btn atlas-btn-primary" (click)="searchBillings(true)">
      <wl-busy *ngIf="rejectionPreviewSearching || previewSearching" [show]="true"></wl-busy>
      {{
        (hasResults ? 'revenue.invoice-generator.search-button-label-clear' : 'revenue.invoice-generator.search-button-label-initial')
          | translate
          | uppercase
      }}
    </button>
  </div>
</div>

<div>
  <div *ngIf="billingPreview.TotalCount || rejectionPreview.TotalCount" class="action-panel-wrapper">
    <p-tabs [value]="activeTabIndex" (onChange)="activeTabIndex = $event.index">
      <p-tablist>
        <p-tab value="0">{{ billingPreview.TotalCount }} {{ 'revenue.invoice-generator.preview-header-label' | translate }}</p-tab>
        <p-tab value="1">{{ rejectionPreview.TotalCount }} {{ 'revenue.invoice-generator.rejection-header-label' | translate }}</p-tab>
      </p-tablist>
      <p-tabpanels>
        <p-tabpanel value="0">
          <div class="action-panel mct-flex mct-row mct-wrap">
            <div>
              <button pButton type="button" class="btn btn-primary" (click)="viewInvoices()" [hidden]="!generateClicked">
                {{ 'revenue.invoice-generator.view-invoices-label' | translate | uppercase }}
              </button>
            </div>
            <div>
              <button
                type="button"
                class="btn btn-primary"
                (click)="generateBillings()"
                [disabled]="!billingPreview?.TotalCount || generateClicked"
              >
                {{ 'revenue.invoice-generator.generate-button-label' | translate | uppercase }}
              </button>
            </div>
            <div>
              <action-button [label]="'revenue.invoice-generator.actions.label' | translate | uppercase" [items]="previewActionOptions">
              </action-button>
            </div>
          </div>
          <p-table
            [showGridlines]="true"
            [lazy]="true"
            [rows]="billingPreview ? billingPreview.PageSize : 20"
            [value]="billingPreview?.Result"
            [totalRecords]="billingPreview?.TotalCount"
            (onLazyLoad)="lazyLoadBillings($event)"
            [paginator]="true"
            [(selection)]="billingPreview.Selected"
          >
            <ng-template pTemplate="sorticon" field="col.field" let-sortOrder>
              <SortAltIcon *ngIf="sortOrder === 0">
                <span><i class="p-sortable-column-icon pi pi-fw pi-sort-alt" aria-hidden="true"></i></span>
              </SortAltIcon>
              <SortAmountUpAltIcon *ngIf="sortOrder === 1" [styleClass]="'p-sortable-column-icon'">
                <span><i class="p-sortable-column-icon pi pi-fw pi-sort-amount-up-alt" aria-hidden="true"></i></span>
              </SortAmountUpAltIcon>
              <SortAmountDownIcon *ngIf="sortOrder === -1" [styleClass]="'p-sortable-column-icon'">
                <span><i class="p-sortable-column-icon pi pi-fw pi-sort-amount-down" aria-hidden="true"></i></span>
              </SortAmountDownIcon>
            </ng-template>
            <ng-template pTemplate="header">
              <tr>
                <th style="width: 50px">
                  <input [(ngModel)]="selectAllPreviews" (ngModelChange)="onSelectAllPreviewChange($event)" type="checkbox" />
                </th>
                <th pSortableColumn="ReportName">
                  {{ 'common.personal-information.profile-name' | translate | titlecase }}
                  <p-sortIcon field="ReportName"></p-sortIcon>
                </th>
                <th pSortableColumn="RevenueItem">
                  {{ 'revenue.invoice-generator.revenue-item-label' | translate | titlecase }}
                  <p-sortIcon field="RevenueItem"></p-sortIcon>
                </th>
                <th pSortableColumn="AmountPerCycle">
                  {{ 'revenue.invoice-generator.amount-per-cycle-label' | translate | titlecase }}
                  <p-sortIcon field="AmountPerCycle"></p-sortIcon>
                </th>
                <th pSortableColumn="BillingCycle">
                  {{ 'revenue.invoice-generator.billing-cycle-label' | translate | titlecase }}
                  <p-sortIcon field="BillingCycle"></p-sortIcon>
                </th>
              </tr>
            </ng-template>
            <ng-template let-billing pTemplate="body">
              <tr>
                <td style="text-align: left !important">
                  <input type="checkbox" [(ngModel)]="billing.Selected" (ngModelChange)="onPreviewSelectedChanged(billing)" />
                </td>
                <td style="text-align: left !important">
                  <a [routerLink]="['/profile/', billing.ProfileId]"
                    ><span>{{ billing.ReportName }}</span></a
                  >
                </td>
                <td>
                  <span>{{ billing.RevenueItem }}</span>
                </td>
                <td>
                  <span>{{ billing.AmountPerCycle | currency }}</span>
                </td>
                <td>
                  <span>{{ billing.BillingCycle }}</span>
                </td>
              </tr>
            </ng-template>
          </p-table>

          <wl-page-size-dropdown
            [(pageSize)]="invoiceGenerationParams.BillingSearchOptions.PageSize"
            [pageSizes]="[20, 100, 0]"
            (pageSizeChange)="billingPageSizeChanged()"
          ></wl-page-size-dropdown>
        </p-tabpanel>
        <p-tabpanel value="1">
          <div class="action-panel mct-flex mct-row mct-wrap">
            <div>
              <button
                type="button"
                class="btn btn-primary"
                (click)="generateBillings()"
                [disabled]="!billingPreview?.TotalCount || generateClicked"
              >
                {{ 'revenue.invoice-generator.generate-button-label' | translate | uppercase }}
              </button>
            </div>
            <div>
              <action-button [label]="'revenue.invoice-generator.actions.label' | translate | uppercase" [items]="rejectionActionOptions">
              </action-button>
            </div>
          </div>
          <p-table
            [showGridlines]="true"
            [lazy]="true"
            [rows]="rejectionPreview ? rejectionPreview.PageSize : 20"
            [value]="rejectionPreview?.Result"
            [totalRecords]="rejectionPreview?.TotalCount"
            (onLazyLoad)="lazyLoadRejections($event)"
            [paginator]="true"
            [(selection)]="rejectionPreview.Selected"
          >
            <ng-template pTemplate="sorticon" field="col.field" let-sortOrder>
              <SortAltIcon *ngIf="sortOrder === 0">
                <span><i class="p-sortable-column-icon pi pi-fw pi-sort-alt" aria-hidden="true"></i></span>
              </SortAltIcon>
              <SortAmountUpAltIcon *ngIf="sortOrder === 1" [styleClass]="'p-sortable-column-icon'">
                <span><i class="p-sortable-column-icon pi pi-fw pi-sort-amount-up-alt" aria-hidden="true"></i></span>
              </SortAmountUpAltIcon>
              <SortAmountDownIcon *ngIf="sortOrder === -1" [styleClass]="'p-sortable-column-icon'">
                <span><i class="p-sortable-column-icon pi pi-fw pi-sort-amount-down" aria-hidden="true"></i></span>
              </SortAmountDownIcon>
            </ng-template>
            <ng-template pTemplate="header">
              <tr>
                <th style="width: 50px">
                  <input [(ngModel)]="selectAllRejections" (ngModelChange)="onSelectAllRejectionChange($event)" type="checkbox" />
                </th>
                <th pSortableColumn="ReportName">
                  {{ 'common.personal-information.profile-name' | translate | titlecase }}
                  <p-sortIcon field="ReportName"></p-sortIcon>
                </th>
                <th pSortableColumn="RevenueItem">
                  {{ 'revenue.invoice-generator.revenue-item-label' | translate | titlecase }}
                  <p-sortIcon field="RevenueItem"></p-sortIcon>
                </th>
                <th pSortableColumn="AmountPerCycle">
                  {{ 'revenue.invoice-generator.amount-per-cycle-label' | translate | titlecase }}
                  <p-sortIcon field="AmountPerCycle"></p-sortIcon>
                </th>
                <th pSortableColumn="BillingCycle">
                  {{ 'revenue.invoice-generator.billing-cycle-label' | translate | titlecase }}
                  <p-sortIcon field="BillingCycle"></p-sortIcon>
                </th>
                <th pSortableColumn="RejectionReasons">
                  {{ 'revenue.invoice-generator.rejection-reason-label' | translate | titlecase }}
                  <p-sortIcon field="RejectionReason"></p-sortIcon>
                </th>
              </tr>
            </ng-template>
            <ng-template let-billing pTemplate="body">
              <tr>
                <td style="text-align: left !important">
                  <input type="checkbox" [(ngModel)]="billing.Selected" (ngModelChange)="onRejectedSelectedChanged(billing)" />
                </td>
                <td style="text-align: left !important">
                  <a [routerLink]="['/profile/', billing.ProfileId]"
                    ><span>{{ billing.ReportName }}</span></a
                  >
                </td>
                <td>
                  <span>{{ billing.RevenueItem }}</span>
                </td>
                <td>
                  <span>{{ billing.AmountPerCycle | currency }}</span>
                </td>
                <td>
                  <span>{{ billing.BillingCycle }}</span>
                </td>
                <td>
                  {{
                    (billing.Duplicate
                      ? 'revenue.invoice-generator.billing-duplicate-reason'
                      : billing.BillManually
                        ? 'revenue.invoice-generator.manual-billing-reason'
                        : billing.Expired
                          ? 'revenue.invoice-generator.billing-expired-reason'
                          : billing.Excluded
                            ? 'revenue.invoice-generator.removed-reason'
                            : ''
                    )
                      | translate
                      | titlecase
                  }}
                </td>
              </tr>
            </ng-template>
          </p-table>

          <wl-page-size-dropdown
            [(pageSize)]="invoiceGenerationParams.RejectedSearchOptions.PageSize"
            [pageSizes]="[20, 100, 0]"
            (pageSizeChange)="rejectionPageSizeChanged()"
          ></wl-page-size-dropdown>
        </p-tabpanel>
      </p-tabpanels>
    </p-tabs>
  </div>
</div>

<p-dialog modal="true" styleClass="atlas-dialog-xl" [closable]="false" [(visible)]="showIncreaseModal">
  <ng-template pTemplate="header">
    {{ 'revenue.invoice-generator.update-amounts' | translate | titlecase }}
  </ng-template>
  <wl-billing-amount-update
    [anchorMonth]="selectedMonth.MonthNum"
    [revenueItems]="selectedRevenueItems"
    [billingYear]="invoiceGenerationParams.BillingYear"
  ></wl-billing-amount-update>
</p-dialog>

<p-dialog modal="true" styleClass="atlas-dialog-xl" [closable]="true" [(visible)]="showDeleteBatchModal" #batch>
  <ng-template pTemplate="header">
    {{ 'revenue.invoice-generator.delete-previous-batch' | translate | titlecase }}
  </ng-template>
  <form #batchSearch>
    <input
      #batchNumber
      type="string"
      class="form-control"
      name="batchNumber"
      [placeholder]="'revenue.invoice-generator.batch-number-placeholder' | translate | ucfirst"
    />
    <p *ngIf="showDelete">
      {{
        'revenue.invoice-generator.delete-batches-warning' | translate: { numberOfBatches: numberOfBatches, batchNumber: batchNumber.value }
      }}
    </p>
  </form>
  <ng-template pTemplate="footer">
    <button pButton type="button" class="atlas-btn atlas-btn-secondary mr-10" (click)="close()">
      {{ 'common.cancel' | translate | uppercase }}
    </button>
    <button pButton type="button" type="submit" *ngIf="!showDelete" class="atlas-btn atlas-btn-primary" (click)="next(batchNumber.value)">
      {{ 'common.next' | translate | uppercase }}
    </button>
    <button pButton type="button" *ngIf="showDelete" class="atlas-btn atlas-btn-danger" (click)="deleteBatch(batchNumber.value)">
      {{ 'revenue.invoice-generator.delete-batches-button' | translate: { numberOfBatches: numberOfBatches } | uppercase }}
    </button>
  </ng-template>
</p-dialog>
